const WEEK_DAYS_LENGHT = 7;
const CALENDAR_DAYS_LENGHT = 42;
const DATEPICKER_HEIGHT = 400;

const MAP_DATEPICKER_PREVIOUS_DAYS = "previous-days";
const MAP_DATEPICKER_CURRENT_DAYS = "current-days";
const MAP_DATEPICKER_NEXT_DAYS = "next-days";

const EVENT_DATEPICKER_CHANGE = "change";
const EVENT_DATEPICKER_INPUT = "input";
const EVENT_DATEPICKER_CLEAR = "clear";

export {
  WEEK_DAYS_LENGHT,
  CALENDAR_DAYS_LENGHT,
  DATEPICKER_HEIGHT,
  EVENT_DATEPICKER_CLEAR,
  EVENT_DATEPICKER_INPUT,
  EVENT_DATEPICKER_CHANGE,
  MAP_DATEPICKER_NEXT_DAYS,
  MAP_DATEPICKER_CURRENT_DAYS,
  MAP_DATEPICKER_PREVIOUS_DAYS,
};
